import { openDB, type DBSchema } from "idb";
import type { Price } from "../types";

interface PriceDB extends DBSchema {
  prices: {
    key: string;
    value: Price;
  };
}

const DB_NAME = "iranian-exchanges";
const DB_VERSION = 1;
const STORE_NAME: "prices" = "prices";

const dbPromise = openDB<PriceDB>(DB_NAME, DB_VERSION, {
  upgrade(db) {
    if (!db.objectStoreNames.contains(STORE_NAME)) {
      db.createObjectStore(STORE_NAME, { keyPath: "ex" });
    }
  },
});

function compactPriceRecord(price: Price): Price {
  // فقط داده‌های اصلی و ضروری رو نگه می‌داریم
  const minimal: Price = {
    ex: price.ex,
    symbol: price.symbol,
    last: price.last,
    ts: price.ts
  };

  // موارد خیلی مهم و کم‌حجم رو نگه می‌داریم
  if (typeof price.takerFee === "number" && Number.isFinite(price.takerFee)) {
    minimal.takerFee = price.takerFee;
  }
  if (typeof price.supportsLightning === "boolean") {
    minimal.supportsLightning = price.supportsLightning;
  }

  return minimal;
}

export async function persistPrice(price: Price): Promise<void> {
  try {
    const db = await dbPromise;
    await db.put(STORE_NAME, compactPriceRecord(price));
  } catch (error) {
    console.warn("[persistence] failed to persist price", error);
  }
}

export async function readCachedPrices(): Promise<Price[]> {
  try {
    const db = await dbPromise;
    const records = await db.getAll(STORE_NAME);
    return records.map(compactPriceRecord);
  } catch (error) {
    console.warn("[persistence] failed to load cached prices", error);
    return [];
  }
}

export async function clearCachedPrices(): Promise<void> {
  try {
    const db = await dbPromise;
    await db.clear(STORE_NAME);
  } catch (error) {
    console.warn("[persistence] failed to clear cached prices", error);
  }
}
